import React from 'react';
import { Tooltip } from 'antd';
import { modes, tooltipTitles, warrantyIds } from '../../../../config';
import IconComponent from '../IconComponent/IconComponent';
import { useChangeWarrantyModalDispatch } from '../../../../model';

const WarrantyComponent = ({ request, actionProps }) => {
  const { open } = useChangeWarrantyModalDispatch();

  const handleClick = (e) => {
    e.stopPropagation();
    open({ request, mode: modes.warrantyToRegular });
  };

  return (
    <Tooltip title={tooltipTitles[warrantyIds.warranty].active}>
      <IconComponent
        {...actionProps}
        warrantyId={warrantyIds.warranty}
        onClick={handleClick}
      />
    </Tooltip>
  );
};

export default WarrantyComponent;
